<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { LicenseComputed } from '@state/modules/license'
import { PreferenceComputed } from '@state/modules/preference'
export default {
  name: 'SmartSuggestionsModule',
  page() {
    return {
      title: this.$t('smart_suggestions'),
    }
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...PreferenceComputed,
    ...LicenseComputed,
  },
  created() {
    // if user doesn't have permission to handle admin AI section
    if (this.myAllowedModules.indexOf('admin.ai') === -1) {
      return this.$router.replace({ name: '404' })
    }
    if (!this.aiEnabled) {
      return this.$router.replace({ name: '404' })
    }
    this.hasPermission = true
  },
}
</script>
